import { TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { GenericModal } from '../../components/GenericModal';

const styles = {
    description: {
        marginBottom: '8px',
    },
    textField: {
        margin: '1rem 0',
        width: '100%',
    },
};

type InviteInstallerModalProps = {
    handleInviteInstaller: (email: string) => void | Promise<void>;
    onClose: () => void;
    loading: boolean;
};

export const InviteInstallerModal: React.FC<InviteInstallerModalProps> = (props) => {
    const { handleInviteInstaller, onClose, loading } = props;
    const { t } = useTranslation();

    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState(false);

    const isValidEmail = (value: string): boolean => z.string().email().safeParse(value).success;

    return (
        <GenericModal
            modalTestId="invite-installer-modal"
            title={t('MANAGE_INSTALLERS_PAGE.INVITE_INSTALLER_MODAL_TITLE')}
            cancelText={t('COMMON.CANCEL')}
            confirmText={t('COMMON.SUBMIT')}
            confirmOnClick={(): void => {
                if (!isValidEmail(email.trim())) {
                    setEmailError(true);
                    return;
                }
                void handleInviteInstaller(email.trim());
            }}
            setShowModal={onClose}
            disable={!email || !isValidEmail(email)}
            loading={loading}
        >
            <>
                <Typography variant="body2" sx={styles.description}>
                    {t('MANAGE_INSTALLERS_PAGE.INVITE_INSTALLER_MODAL_BODY')}
                </Typography>
                <TextField
                    data-testid="invite-installer-email-input"
                    label={t('MANAGE_INSTALLERS_PAGE.EMAIL_LABEL')}
                    sx={styles.textField}
                    value={email}
                    onChange={(e): void => {
                        setEmailError(false);
                        setEmail(e.target.value);
                    }}
                    error={emailError}
                    helperText={emailError ? t('VALIDATION_ERRORS.MANAGE_INSTALLERS_PAGE.EMAIL_ERROR') : undefined}
                    onBlur={(): void => {
                        if (email !== '') {
                            setEmailError(!isValidEmail(email));
                        }
                    }}
                    type="email"
                    fullWidth
                />
            </>
        </GenericModal>
    );
};
